<template lang="pug">
ValidationObserver(
  ref='form'
  slim
  v-slot='{ valid }'
)
  #bulk-send-envelopes-add-recipients.mb-5
    .bulk-send-page
      bulk-send-step-bar(:step='2')
      h5.title(
        v-html='$t("configureBulkSend.recipients.title", { modelName: template.title })'
      )
      p {{ $t('configureBulkSend.recipients.message') }}
      #select-recipients-source.template-list
        .row.gx-2.gy-2
          .alert.alert-warning.alert-dismissible.fade.show(
            role='alert'
            v-if='templateMaxRecipients === 0'
          )
            div(style='display: flex; align-items: center')
              icon.icon-left(name='circle-exclamation')
              span(style='font-weight: bold; margin-right: 10px')
                | {{ $t('configureBulkSend.recipients.invalidTemplate') }}
          .col-12.col-md-6(:key='item.name' v-for='(item, index) in options')
            label.templates-list-item(:for='`recipient-option-${item.name}`')
              input.checkbox.form-check-input(
                :checked='selectedOption === item.name'
                :disabled='(isProcessedCsv && !isEditingDraft) || templateMaxRecipients === 0'
                :id='`recipient-option-${item.name}`'
                @change='selectedOption = item.name'
                type='radio'
              )
              .card-section
                .card-section-header
                  .card-section-icon.card-section-icon--green
                    icon(:name='getIconName(item)')
                  .card-section-title.text-break {{ $t(`configureBulkSend.recipients.${item.name}.title`) }}
                span.text {{ getOptionMessage(item.name) }}
      #alert-replace-recipients-when-edit-draft.row.mt-4(v-if='isEditingDraft')
        .alert.alert-warning.alert-dismissible.fade.show(
          role='alert'
          v-if='hasPersistedRecipients && canBeReplaceRecipients'
        )
          div(style='display: flex; align-items: center')
            icon.icon-left(name='circle-exclamation')
            span(v-html='$t("configureBulkSend.editDraft.recipientsWarning")')
            button.close(
              aria-label='Close'
              data-bs-dismiss='alert'
              type='button'
            )
              span &times
      #only-failed-rows-processed-csv.row
        .col-12.mt-4(v-if='isUpload && isProcessedCsv && onlyFailedRows')
          .alert.alert-warning.alert-dismissible.fade.show(role='alert')
            div(style='display: flex; align-items: center')
              icon.icon-left(name='circle-exclamation')
              span(style='font-weight: bold; margin-right: 10px')
                | {{ $t('configureBulkSend.recipients.upload.warning') }}!
              button.close(
                aria-label='Close'
                data-bs-dismiss='alert'
                type='button'
              )
                span &times
          div
            button.btn.btn-primary-outline.mb-4(
              @click='replaceCsv'
              style='border-width: 1px'
              type='button'
              v-tooltip:bottom='$t("configureBulkSend.recipients.upload.tooltipReplaceCsv")'
            )
              span.text {{ $t('configureBulkSend.recipients.upload.replaceCsv') }}
      #upload-csv-area.mt-4(v-show='showUploadCsvArea')
        bulk-send-upload-area(
          :allowedFileExtensions='allowedFileExtensions'
          :allowedFileType='allowedFileType'
          :maxFilesPerUpload='maxFilesPerUpload'
          :uploadedFile='uploadedFile'
          @downloadExample='downloadCsvExample'
          @onSelectFiles='onSelectFiles'
        )
      .mb-5(v-if='hasPersistedCsvRecipients')
        bulk-send-files-card-table(
          :data='[bulkSend]'
          :show-failed='!isManual'
          v-if='!replaceCsvFile'
        )
      //- Start - Manually Recipients
      .mt-4(v-if='isManual')
        #alert-manual-entries-limit.alert.alert-warning.alert-dismissible.fade.show(
          role='alert'
          v-if='passManualEntriesLimit'
        )
          div(style='display: flex; align-items: center')
            icon.icon-left(name='circle-exclamation')
            span(style='font-weight: bold; margin-right: 10px')
              | {{ $t('configureBulkSend.recipients.manual.limitMessage', { entriesLimit: bulkSendEntriesLimit }) }}
            span(
              v-html='$t("configureBulkSend.recipients.manual.limitWarning")'
            )
            button.close(
              aria-label='Close'
              data-bs-dismiss='alert'
              type='button'
            )
              span &times
        bulk-send-manual-entries(
          :entries='entries'
          :hasFeatureWhatsapp='hasFeatureWhatsapp'
          @removeEntry='removeEntry($event)'
        )
      .d-flex.mb-0(
        :class='hasManuallyRecipients ? "justify-content-between" : "justify-content-center"'
        :style='hasManuallyRecipients ? "margin-top: -23px" : ""'
        style='margin-bottom: 90px'
        v-if='isManual'
      )
        button.btn.btn-thin(
          :disabled='hasDuplicateAddresses || passManualEntriesLimit'
          @click='addEmptyEntry'
          aria-expanded='false'
          type='button'
        )
          span.text {{ $t('modal.envelope.add') }}
      envelope-bottom-bar.bulk-send-page__bottom-bar(
        :disableButtonNextStep='disabledNextStep || (isManual && !valid)'
        :discardAndClose='false'
        @discardAndClose='discardChanges'
        @nextStep='next'
        @saveAndClose='saveAndClose'
      )

      warning-save-and-close-bulk-send-modal(
        @discardChanges='discardChanges'
        @saveAndClose='saveAndClose'
        ref='saveAndCloseModal'
      )
        p.mb-0 {{ $t('configureBulkSend.confirmDiscard') }}
</template>

<script>
import BulkSendStepBar from '@/ui/organisms/BulkSendStepBar.vue';
import EnvelopeBottomBar from '@/ui/organisms/EnvelopeBottom.vue';
import WarningSaveAndCloseBulkSendModal from '@/modules/business/components/organisms/modals/WarningSaveAndCloseBulkSend.vue';
import Icon from '@/ui/atoms/Icon.vue';
import EnvelopesService from '@/modules/business/services/http/envelopes/EnvelopesService';
import FileSaver from 'file-saver';
import FileLocalLoaderModal from '@/ui/organisms/modals/FileLocalLoaderModal.vue';
import ToastAlert from '@/modules/account/common/alert';
import BulkSendFilesCardTable from '@/modules/business/components/organisms/card-table/BulkSendFilesCardTable.vue';
import Draggable from 'vuedraggable';
import InputTel from '@/ui/molecules/InputTel.vue';
import alert from '@/modules/account/common/alert';
import DeleteRecipientModal from '@/modules/business/components/organisms/modals/ChangeTypeSignerModal.vue';
import BulkSendService from '@/modules/business/services/BulkSendService';
import BulkSendManualEntries from '@/modules/business/components/organisms/forms/BulkSendManualEntries.vue';
import BulkSendUploadArea from '@/modules/business/components/organisms/BulkSendUploadArea.vue';

const recipientModel = {
  name: '',
  role: '',
  routing_order: '',
  contact: '',
  email: '',
  phone: '',
  updated: false,
  shippingType: 'email',
  isInvalid: false,
  errors: {},
  inServer: false,
};

export default {
  name: 'BulkSendAddRecipients',
  components: {
    BulkSendUploadArea,
    BulkSendManualEntries,
    DeleteRecipientModal,
    InputTel,
    BulkSendFilesCardTable,
    FileLocalLoaderModal,
    WarningSaveAndCloseBulkSendModal,
    BulkSendStepBar,
    EnvelopeBottomBar,
    Icon,
    Draggable,
  },
  beforeRouteLeave(to, from, next) {
    if (
      to.name === 'business.bulk-send.recipients' ||
      to.name === 'business.bulk-send.template' ||
      to.name === 'business.bulk-send.review'
    ) {
      next();
      return;
    }
    this.$refs.saveAndCloseModal.$refs.modal.open();
    this.nextRoute = next;
  },
  data() {
    return {
      nextRoute: null,
      hasError: false,
      bulkSendId: null,
      bulkSend: {},
      template: {},
      entries: [],
      files: [],
      replaceCsvFile: false,
      allowedMimeTypes: ['text/csv'],
      allowedFileExtensions: ['csv'],
      allowedFileType: [].concat(['csv'], ['text/csv']),
      uploadedFile: null,
      maxFilesPerUpload: 1,
      options: [
        {
          name: 'csv',
          index: 0,
        },
        {
          name: 'manual',
          index: 1,
        },
      ],
      selectedOption: '',
      nextEntryId: 1,
    };
  },
  async created() {
    this.updatePageTitleAndHead();

    this.bulkSendId = this.$route.params.id ?? null;

    this.$loading(true);
    await this.fetchBulkSend();
    if (this.hasError) {
      console.error('Error fetching bulk send data');
      return;
    }

    this.template = this.bulkSend.envelope;
    this.initSelectedOption();
    this.$loading(false);

    if (
      this.hasPersistedRecipients &&
      !this.$route.params.back &&
      (!this.canBeReplaceRecipients || !this.isEditingDraft) &&
      !this.onlyFailedRows
    ) {
      await this.$router.replace({
        name: 'business.bulk-send.review',
        params: {
          id: this.bulkSendId,
          isNew: this.isNew,
          editDraftBulkSend: this.isEditingDraft,
        },
      });
    }
  },
  async mounted() {
    this.$store.dispatch('envelopeConfig/fetchConfigs');
    if (this.hasFiles || this.isProcessedCsv) {
      this.selectedOption = 'csv';
    }
  },
  watch: {
    selectedOption() {
      if (this.selectedOption === 'manual' && this.entries.length === 0) {
        this.addEmptyEntry();
      }
    },
  },
  computed: {
    isEditingDraft() {
      return this.$route.params.editDraftBulkSend === true;
    },
    isProcessedCsv() {
      return Boolean(this.isDraftBulkSend && this.hasPersistedCsvRecipients);
    },
    showUploadCsvArea() {
      return (
        this.isUpload &&
        (!this.isProcessedCsv ||
          this.replaceCsvFile ||
          this.isEditingDraft ||
          this.canBeReplaceRecipients) &&
        this.templateMaxRecipients > 0
      );
    },
    hasPersistedRecipients() {
      const manualPersisted = this.bulkSend?.entries?.length > 0;
      return this.hasPersistedCsvRecipients || manualPersisted;
    },
    hasPersistedCsvRecipients() {
      const bulkSendFileResult = this.bulkSend?.file_result ?? {};
      return Object.hasOwn(bulkSendFileResult, 'total_rows');
    },
    bulkSendEntriesLimit() {
      return this.$store.getters['envelopeConfig/bulkSendEntriesLimit'] || 50;
    },
    hasManuallyRecipients() {
      return this.isManual && this.entries.length > 0;
    },
    hasDuplicateAddresses() {
      if (!this.isManual) {
        return false;
      }
      return (
        this.isManual &&
        this.entries.some((entry) => {
          const contacts = entry.recipients
            .map((recipient) =>
              recipient.shippingType === 'whatsapp'
                ? recipient.phone
                : recipient.email
            )
            .filter(Boolean);
          return contacts.length !== new Set(contacts).size;
        })
      );
    },
    isDraftBulkSend() {
      return BulkSendService.checkBulkSendIsDraft(this.bulkSend);
    },
    canBeReplaceRecipients() {
      return Boolean(
        (this.isDraftBulkSend && this.bulkSend?.entries?.length > 0) ||
          (this.isDraftBulkSend && this.bulkSend?.file_result?.valid_rows > 0)
      );
    },
    templateRecipients() {
      return this.template?.recipients ?? [];
    },
    templateMaxRecipients() {
      return this.template?.recipients?.length || 0;
    },
    passManualEntriesLimit() {
      return this.isManual && this.bulkSendEntriesLimit < this.entries.length;
    },
    onlyFailedRows() {
      const result = this.bulkSend?.file_result;
      return Boolean(
        result &&
          result.invalid_rows > 0 &&
          result.invalid_rows === result.total_rows
      );
    },
    disabledNextStep() {
      return (
        this.hasError ||
        (this.isUpload && !this.isProcessedCsv) ||
        (this.isUpload && this.onlyFailedRows) ||
        (this.isManual && !this.hasManuallyRecipients) ||
        this.passManualEntriesLimit ||
        this.hasDuplicateAddresses
      );
    },
    getPageTitle() {
      return this.isNew || !this.isEditingDraft
        ? this.$t('newBulkSend')
        : this.$t('editBulkSend');
    },
    isNew() {
      return this.$route.params.isNew === true;
    },
    isUpload() {
      return this.selectedOption === 'csv';
    },
    isManual() {
      return this.selectedOption === 'manual';
    },
    hasFiles() {
      return this.files.length > 0 || this.uploadedFile;
    },
    hasFeatureWhatsapp() {
      if (this.$root.isUSAVersion) {
        return false;
      }

      if (this.$store.getters['subscription/isPostpaid']) {
        return true;
      }

      const feature = this.$store.state.subscription.plan.plan.features
        .filter((i) => i.feature === 'whatsapp')
        .shift();
      if (!feature) {
        return false;
      }
      return !!feature.feature;
    },
    shippingTitle() {
      return this.hasFeatureWhatsapp
        ? this.$t('recipients.shippingTitle.sendEnvelope')
        : this.$t('recipients.shippingTitle.emailAddress');
    },
  },
  methods: {
    updatePageTitleAndHead() {
      const pageTitle = this.getPageTitle;
      // const self = this; // TODO uncomment when can be change bulk-send  template in future version
      this.$store.dispatch('page/setTitle', pageTitle);
      this.$store.dispatch('page/setHead', {
        title: pageTitle,
        // action() {
        //   self.$router.replace({
        //     name: 'business.bulk-send.template',
        //     params: {
        //       id: self.$route.params.id,
        //       isNew: self.$route.params.isNew,
        //       back: true,
        //     },
        //   }); // TODO uncomment when can be change bulk-send  template in future version
        // },
      });
    },
    async fetchBulkSend() {
      this.hasError = false;
      this.$loading(true);
      await EnvelopesService.getBulkSend(this.bulkSendId)
        .then((response) => {
          this.bulkSend = response.data;
        })
        .catch((error) => {
          this.hasError = true;
          console.error('Error fetching bulk send:', error);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
    addEmptyEntry() {
      if (
        this.entries.length >= this.bulkSendEntriesLimit ||
        this.templateRecipients.length === 0
      ) {
        return;
      }

      this.entries.push({
        id: this.nextEntryId++,
        inServer: false,
        recipients: this.templateRecipients.map(
          (templateRecipient, templateRecipientIndex) => ({
            ...recipientModel,
            errors: {},
            templateRecipientIndex,
            role: templateRecipient.role ?? '',
            routing_order:
              templateRecipient.routing_order === ''
                ? null
                : templateRecipient.routing_order ?? null,
          })
        ),
      });
    },
    removeEntry(entry) {
      try {
        this.entries = this.entries.filter((item) => item.id !== entry.id);
      } catch (e) {
        let message = this.$t('http.defaultError') + ' : ' + e.message;
        alert.fireAlert(message, {
          classes: 'alert-danger',
          styles:
            'background-color: #f8d7da; border-color: #F5C6CB; color: #721C24;',
          tag: 'httpAlert',
          icon: 'circle-exclamation',
        });
      }
    },
    async saveRecipientsManually() {
      this.hasError = false;
      const payload = this.entries.map((entry) =>
        entry.recipients.map((recipient) => {
          const numberIndex =
            recipient.routing_order ?? recipient.templateRecipientIndex + 1;
          const recipient_index = recipient.role || `recipient_${numberIndex}`;
          // payload example [{ role: 'role', name: 'name', contact: 'email/phone'}]
          return {
            role: recipient_index,
            name: recipient.name,
            contact:
              recipient.shippingType === 'whatsapp'
                ? recipient.phone
                : recipient.email,
          };
        })
      );

      if (this.entries.length > this.bulkSendEntriesLimit) {
        this.hasError = true;
        alert.fireAlert(
          this.$t('configureBulkSend.recipients.manual.limitMessage', {
            entriesLimit: this.bulkSendEntriesLimit,
          }),
          {
            classes: 'alert-danger',
            styles:
              'background-color: #f8d7da; border-color: #F5C6CB; color: #721C24;',
            tag: 'httpAlert',
            icon: 'circle-exclamation',
          }
        );
        return;
      }

      this.$loading(true);
      await EnvelopesService.addBulkSendRecipientsManually(
        this.bulkSend.uuid,
        payload
      )
        .then((response) => {
          this.bulkSend = response.data;
        })
        .catch((error) => {
          this.hasError = true;
          console.error('Error adding recipients manually:', error);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
    initSelectedOption() {
      if (
        (this.isEditingDraft || !this.isNew) &&
        this.canBeReplaceRecipients &&
        this.bulkSend?.entries?.length > 0
      ) {
        this.populateInServerEntriesRecipients();
        this.selectedOption = 'manual';
        return;
      }
      this.selectedOption = 'csv';
    },
    populateInServerEntriesRecipients() {
      const inServerRecipients = this.bulkSend.entries ?? [];
      if (inServerRecipients.length > 0) {
        this.entries = inServerRecipients.map((entry) => ({
          id: this.nextEntryId++,
          uuid: entry.uuid,
          inServer: true,
          recipients: this.templateRecipients.map(
            (templateRecipient, templateRecipientIndex) => {
              const routingOrder =
                templateRecipient.routing_order === ''
                  ? null
                  : templateRecipient.routing_order ?? null;

              const recipientRole =
                templateRecipient.role ||
                `recipient_${routingOrder ?? templateRecipientIndex + 1}`;

              const persistedRecipient = (entry.data ?? []).find(
                (recipient) => recipient.role === recipientRole
              );

              const contact = persistedRecipient?.contact ?? '';

              const shippingType =
                contact && !contact.includes('@') ? 'whatsapp' : 'email';

              return {
                ...recipientModel,
                errors: {},
                templateRecipientIndex,
                role: templateRecipient.role ?? '',
                routing_order: routingOrder,
                name: persistedRecipient?.name ?? '',
                contact,
                shippingType,
                email: shippingType === 'email' ? contact : '',
                phone: shippingType === 'whatsapp' ? contact : '',
                updated: false,
                inServer: Boolean(persistedRecipient),
              };
            }
          ),
        }));
      }
    },
    async saveAndClose() {
      if (this.isManual) {
        if (this.entries.length === 0) {
          return;
        }
        const valid = await this.$refs.form.validate();
        if (!valid) {
          alert.fireAlert(
            this.$t('configureBulkSend.recipients.manual.error', {
              entriesLimit: this.bulkSendEntriesLimit,
            }),
            {
              classes: 'alert-danger',
              styles:
                'background-color: #f8d7da; border-color: #F5C6CB; color: #721C24;',
              tag: 'httpAlert',
              icon: 'circle-exclamation',
            }
          );
          return;
        }
        await this.saveRecipientsManually();
      }

      if (this.hasError) {
        return;
      }

      if (this.nextRoute) {
        this.nextRoute();
        return;
      }
      this.$router.push({ name: 'business.documents.bulk-send' });
    },
    async next() {
      if (this.isManual && this.entries.length === 0) {
        return;
      }

      if (this.isUpload && (!this.isProcessedCsv || this.onlyFailedRows)) {
        return;
      }

      if (this.isManual) {
        const valid = await this.$refs.form.validate();
        if (!valid) {
          return;
        }
        await this.saveRecipientsManually();
      }

      if (this.hasError) {
        return;
      }

      await this.$router.replace({
        name: 'business.bulk-send.review',
        params: {
          id: this.bulkSendId,
          isNew: this.isNew,
          editDraftBulkSend: this.isEditingDraft,
        },
      });
    },
    discardChanges() {
      if (this.nextRoute) {
        this.nextRoute();
        return;
      }
      this.$router.go(-1);
    },
    getIconName(options) {
      return options.name === 'csv' ? 'file-excel' : 'user-plus';
    },
    getOptionMessage(optionName) {
      return optionName === 'csv'
        ? this.$t(`configureBulkSend.recipients.${optionName}.message`)
        : this.$t(`configureBulkSend.recipients.${optionName}.message`, {
            entriesLimit: this.bulkSendEntriesLimit,
          });
    },
    replaceCsv() {
      this.replaceCsvFile = true;
      this.files = [];
      this.uploadedFile = null;
    },
    async onSelectFiles(selectedFile) {
      this.hasError = false;
      this.files = [].concat(selectedFile);
      if (this.maxFilesPerUpload < this.files.length) {
        ToastAlert.fireAlert(
          this.$t('modal.envelope.maxFilesPerEnvelopeError', {
            maxFilesPerEnvelope: this.maxFilesPerUpload,
          }),
          {
            classes: 'alert-warning',
            styles:
              'background-color: #FFFCE2; border-color: #EBE5A7; color: #635B00;',
            tag: 'httpAlert',
            icon: 'circle-exclamation',
          }
        );
        this.hasError = true;
        return;
      }
      this.$loading(true);
      await EnvelopesService.addBulkSendRecipientsUpload(
        this.bulkSend.uuid,
        this.files[0].file
      )
        .then(async (response) => {
          this.uploadedFile = response.data;
          this.replaceCsvFile = false;
          await this.fetchBulkSend();
        })
        .catch(() => {
          this.hasError = true;
          this.selectedOption = 'csv';
        })
        .finally(() => {
          this.$loading(false);
        });
    },
    async downloadCsvExample() {
      this.$loading(true);
      this.hasError = false;
      await EnvelopesService.downloadBulkSendCsvExample(this.bulkSend.uuid)
        .then((response) => {
          FileSaver.saveAs(
            new Blob([response.data]),
            `bulk-send-example-${this.bulkSend.name}.csv`
          );
        })
        .catch(() => {
          this.hasError = true;
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
};
</script>

<style scoped lang="stylus">
.bulk-send-page
  display: flex
  flex-direction: column
  min-height: calc(100vh - 240px)

.bulk-send-page__bottom-bar
  margin-top: auto !important
  padding-top: 1.5rem
  flex-shrink: 0

.templates-list-item
  border-radius: 3px
  display: block
  position: relative
  padding: 1rem 1rem 1rem 2rem
  box-shadow: 0px 0px 3px 1px #dadada
  cursor: pointer
  position: relative
  padding-left: 2rem
  white-space: normal
  overflow: visible
  text-overflow: clip
  color: #555555
  width: 100%
  font-size: 0.875rem
  .checkbox
    position: absolute
    left: 1rem
    top: 50%
    transform: translate(-50%, -50%)
    margin: 0

.pagination-space
  display: inline-block

.card-section
  display: grid
  grid-template-columns: 2.75rem minmax(0, 1fr)
  grid-template-rows: auto auto
  column-gap: 0.75rem
  row-gap: 0.25rem

  & + .card-section
    margin-top: 1.25rem
    padding-top: 1.25rem
    border-top: 1px solid rgba(204, 204, 204, .5)

.card-section-header
  display: contents
  align-items: center
  gap: 0.75rem
  margin-bottom: 1rem

.card-section-icon
  display: flex
  align-items: center
  justify-content: center
  flex: 0 0 auto
  width: 2.75rem
  height: 2.75rem
  border-radius: 50%
  font-size: 1.25rem
  grid-column: 1
  grid-row: 1 / 3
  align-self: center

  &--green
    background-color: #E7F0EF
    color: #19665B

.card-section-title
  font-weight: 600
  font-size: 0.95rem
  grid-column: 2
  grid-row: 1
  min-width: 0

.card-section > .text
  grid-column: 2
  grid-row: 2
  min-width: 0

h5
  color: #19665B
</style>
